import {
    COPILOT_CHECKED_PERMISSIONS,
    COPILOT_ONLY_PERMISSIONS,
    DIRECTORY_CHECKED_PERMISSIONS,
    DIRECTORY_ONLY_PERMISSIONS,
} from "./microsoftPermissions.js";

export const COPY_TARGET = {
    COPILOT: "copilot",
    DIRECTORY: "directory",
};

const TARGETS = {
    [COPY_TARGET.COPILOT]: {
        capability: "Copilot capture",
        needs: COPILOT_ONLY_PERMISSIONS,
        checked: COPILOT_CHECKED_PERMISSIONS,
    },
    [COPY_TARGET.DIRECTORY]: {
        capability: "Directory sync",
        needs: DIRECTORY_ONLY_PERMISSIONS,
        checked: DIRECTORY_CHECKED_PERMISSIONS,
    },
};

export function PermissionNames({ permissions }) {
    return permissions.map((permission, index) => (
        <span key={permission.scope}>
            {index > 0 ? (index === permissions.length - 1 ? " and " : ", ") : null}
            <code className="font-mono">{permission.scope}</code>
        </span>
    ));
}

export default function CopiedMicrosoftAppNote({ target, managed, source, className = "" }) {
    const { capability, needs, checked } = TARGETS[target];
    if (managed) {
        return (
            <p className={className}>
                Uses the same Microsoft app and admin consent as {source}. There is nothing new to grant.
            </p>
        );
    }
    return (
        <>
            <p className={className}>
                Uses the same app registration as {source}. {capability} also needs{" "}
                <PermissionNames permissions={needs} /> on that app, as Application permissions with admin
                consent granted.
            </p>
            <p className={className}>
                When you connect, Origin checks the app for <PermissionNames permissions={checked} /> and stops
                if one is missing.
            </p>
            <p className={className}>
                If you change its client secret later, edit both connections: enter the new secret on the Entra
                connection under Edit, and on the Copilot connection in Connected services under Edit connection.
            </p>
        </>
    );
}
